import $ from "jquery";
import axios from "axios";
import {buttonTariffPlanHandler} from "JQueryScripts/data-layer-handlers/button-tariff-plan-handler";

const url = '/rest/user/license/create';
const DOWNLOAD_URL = '/download';

export const handlerTariffBtns = () => {
    $('.button-tariff').click(async function (e) {
        e.stopPropagation();

        if (initAnnouncement($(this))) {
            return;
        }

        const id = $('.pricing-tables__tabs .tabs__item--active').data('id') === 'tabs-annual-payment' ?
            $(this).data('annual-id') :
            $(this).data('monthly-id');

        //const quantity = $('#tariff-quantity').val();
        const quantity = $(this).data('quantity');

        if (quantity > 10) {
            alert('Quantity can not be more than 10');

            return;
        }

        if ($(this).is('.button-tariff-plan-pro, .button-tariff-pro')) {
            await buttonTariffPlanHandler('pro');
        }

        if ($(this).data('is-free') === 1) {
            window.location.href = DOWNLOAD_URL;

            return;
        }

        axios.post(url, {tariffId: id, quantity: quantity})
            .then((response) => {
                window.location.href = response.data;
            });
    });
};

const initAnnouncement = (parentBtn) => {
    if (parentBtn.data('announcement') === undefined) {
        return false;
    }

    let popup = $('#tariff-announcement');
    let popupConfirmBtn = $('.modal#tariff-announcement .button-tariff-popup');
    const popupCancelBtn = $('.modal#tariff-announcement .button-tariff-popup-cancel');

    popupConfirmBtn.attr('data-annual-id', parentBtn.data('annual-id'));
    popupConfirmBtn.attr('data-monthly-id', parentBtn.data('monthly-id'));
    popupConfirmBtn.attr('data-quantity', parentBtn.data('quantity'));
    popupConfirmBtn.attr('data-is-free', parentBtn.data('is-free'));

    popupCancelBtn.click(function (e) {
        e.stopPropagation();

        popup.modal('hide');
    });

    popup.modal('show');

    return true;
};